/** @jsxImportSource @emotion/react */

import { useOrganizer } from 'modules/organizer/ui/hooks/use-organizer';
import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { AppDispatch } from 'store/store';
import { authStoreUserTournamentId } from 'modules/auth/store/selectors';
import { Pages } from 'modules/navigation/domain/enums/pages';
import { UDText } from 'ud-ui/components';
import UDBreadcrumbs from 'ud-ui/components/breadcrumbs';
import { useMainLayout } from 'ud-ui/layout/main/context';
import { UpsertLocationInput } from '../../domain/interfaces/actions';
import { upsertLocation } from '../../store/actions';
import { selectLoad } from '../../store/selectors';
import LocationForm from '../components/location-form';

function LocationCreatePage() {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { isLoading } = useSelector(selectLoad);
  const tournamentId = useSelector(authStoreUserTournamentId);
  const { info } = useOrganizer();
  const { setHeaderContent } = useMainLayout();

  const breadcrumb = useMemo(
    () => (
      <UDBreadcrumbs
        className="my-10"
        breadcrumbs={[
          { label: 'Локации', to: Pages.LOCATIONS.INDEX },
          { label: 'Добавление локации', to: Pages.LOCATIONS.CREATE },
        ]}
      />
    ),
    [],
  );

  const handleSubmit = useCallback(
    async (values: UpsertLocationInput) => {
      if (!tournamentId) {
        console.error('No tournament selected');
        return;
      }

      try {
        const locationData: UpsertLocationInput = {
          ...values,
          tournamentId,
        };

        const result = await dispatch(upsertLocation(locationData)).unwrap();
        navigate(Pages.LOCATIONS.builders.edit(result.id));
      } catch (error) {
        console.error('Failed to create location:', error);
      }
    },
    [dispatch, navigate, tournamentId],
  );

  useEffect(() => {
    setHeaderContent(breadcrumb);
    return () => setHeaderContent(null);
  }, [breadcrumb, setHeaderContent]);

  return (
    <>
      <div className="container py-6">
        <UDText type="headline" className="mr-10">
          Локация для проведения турнира
        </UDText>
      </div>
      <div className="d-flex align-items-center bb-1 container" />
      <div className={'container pt-6'}>
        <LocationForm
          isLoading={isLoading}
          onSubmit={handleSubmit}
          tournamentId={tournamentId || undefined}
          action="create"
          isAvailableFeatures={Boolean(info?.tournamentPlan)}
        />
      </div>
    </>
  );
}

export default LocationCreatePage;
